import { useMemo } from 'react';
import i18n from 'i18next';
import { useConfig } from '../../context';
import { StepsEnum } from '../../types';
export const useAvailableSteps = (steps, activeStep) => {
    const config = useConfig().global;
    const defaultSteps = useMemo(() => {
        return {
            [StepsEnum.Flights]: {
                label: i18n.t('Stepbar:Flights')
            },
            [StepsEnum.Passengers]: {
                label: i18n.t('Stepbar:Passengers')
            },
            [StepsEnum.Order]: {
                label: i18n.t('Stepbar:Order')
            },
            [StepsEnum.Payment]: {
                label: i18n.t('Stepbar:Payment')
            }
        };
    }, [i18n.language]);
    const availableSteps = useMemo(() => {
        var _a;
        const actualSteps = steps ? Object.assign({}, steps) : defaultSteps;
        if (((_a = config.stepsAvailable) === null || _a === void 0 ? void 0 : _a[StepsEnum.Meal]) === false) {
            delete actualSteps.Meal;
        }
        return actualSteps;
    }, [defaultSteps, steps, config.stepsAvailable]);
    const currentAvailableStepIndex = useMemo(() => {
        const index = Object.values(availableSteps).findIndex(step => step.type === (activeStep === null || activeStep === void 0 ? void 0 : activeStep.type));
        return index === -1 ? 0 : index;
    }, [availableSteps, activeStep === null || activeStep === void 0 ? void 0 : activeStep.type]);
    return {
        availableSteps,
        currentAvailableStepIndex
    };
};
